import { Member, Space } from '@tribeplatform/gql-client/types'

export const MESSAGING_POST_TYPE_SLUG = 'tribe-message'

export const generateChatPath = (chatSpace: Partial<Space>) =>
  chatSpace ? `/messaging/${chatSpace.slug}` : '/messaging'

export const generateNewChatPath = (member: Partial<Member> = undefined) =>
  member?.id ? `/messaging/new?member=${member.id}` : '/messaging/new'
